import { emptySplitApi as api } from "../../../emptyApi";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    apiPortalV1EmployeeEmailDeliveryStatusRetrieve: build.query<
      ApiPortalV1EmployeeEmailDeliveryStatusRetrieveApiResponse,
      ApiPortalV1EmployeeEmailDeliveryStatusRetrieveApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/employee/email/delivery-status/`,
        params: {
          token: queryArg.token,
        },
      }),
    }),
    apiPortalV1EmployeeEmailEmailDeliveryStatusRetrieve: build.query<
      ApiPortalV1EmployeeEmailEmailDeliveryStatusRetrieveApiResponse,
      ApiPortalV1EmployeeEmailEmailDeliveryStatusRetrieveApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/employee/email/email-delivery-status/`,
        params: {
          email: queryArg.email,
        },
      }),
    }),
    apiPortalV1EmployeeEmailMessageDeliveryStatusRetrieve: build.query<
      ApiPortalV1EmployeeEmailMessageDeliveryStatusRetrieveApiResponse,
      ApiPortalV1EmployeeEmailMessageDeliveryStatusRetrieveApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/employee/email/message-delivery-status/`,
        params: {
          message_id: queryArg.messageId,
        },
      }),
    }),
    apiPortalV1EmployeeEmailResendInvitationCreate: build.mutation<
      ApiPortalV1EmployeeEmailResendInvitationCreateApiResponse,
      ApiPortalV1EmployeeEmailResendInvitationCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/employee/email/resend-invitation/`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    apiPortalV1EmployeeEmailValidateEmailCreate: build.mutation<
      ApiPortalV1EmployeeEmailValidateEmailCreateApiResponse,
      ApiPortalV1EmployeeEmailValidateEmailCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/employee/email/validate-email/`,
        method: "POST",
        params: {
          token: queryArg.token,
        },
      }),
    }),
    apiPortalV1EmployeeEmailValidateTokenCreate: build.mutation<
      ApiPortalV1EmployeeEmailValidateTokenCreateApiResponse,
      ApiPortalV1EmployeeEmailValidateTokenCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/api/portal/v1/employee/email/validate-token/`,
        method: "POST",
        params: {
          token: queryArg.token,
        },
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as portalApi };
export type ApiPortalV1EmployeeEmailDeliveryStatusRetrieveApiResponse =
  /** status 200  */ {
    delivery_status?: string;
    sent?: string;
    status?: number;
  };
export type ApiPortalV1EmployeeEmailDeliveryStatusRetrieveApiArg = {
  /** Signup token to check delivery status */
  token: string;
};
export type ApiPortalV1EmployeeEmailEmailDeliveryStatusRetrieveApiResponse =
  /** status 200  */ {
    Messages?: {
      MessageID?: string;
      Subject?: string;
      ReceivedAt?: string;
    }[];
  };
export type ApiPortalV1EmployeeEmailEmailDeliveryStatusRetrieveApiArg = {
  /** Email address to check delivery status */
  email: string;
};
export type ApiPortalV1EmployeeEmailMessageDeliveryStatusRetrieveApiResponse =
  /** status 200  */ {
    delivery_status?: string;
    sent?: string;
    status?: number;
  };
export type ApiPortalV1EmployeeEmailMessageDeliveryStatusRetrieveApiArg = {
  /** Message ID to check delivery status */
  messageId: string;
};
export type ApiPortalV1EmployeeEmailResendInvitationCreateApiResponse =
  /** status 200  */ {
    message?: string;
    success?: boolean;
  };
export type ApiPortalV1EmployeeEmailResendInvitationCreateApiArg = {
  body: {
    /** Employee ID to resend invitation to */
    employee_id: number;
  };
};
export type ApiPortalV1EmployeeEmailValidateEmailCreateApiResponse =
  /** status 200  */ {
    message?: string;
    error?: string;
  };
export type ApiPortalV1EmployeeEmailValidateEmailCreateApiArg = {
  /** Email validation token */
  token: string;
};
export type ApiPortalV1EmployeeEmailValidateTokenCreateApiResponse =
  /** status 200  */ {
    valid?: boolean;
    first_name?: string;
    last_name?: string;
    email?: string;
    message?: string;
    next_steps?: number;
  };
export type ApiPortalV1EmployeeEmailValidateTokenCreateApiArg = {
  /** Signup token to validate */
  token: string;
};
export const {
  useApiPortalV1EmployeeEmailDeliveryStatusRetrieveQuery,
  useApiPortalV1EmployeeEmailEmailDeliveryStatusRetrieveQuery,
  useApiPortalV1EmployeeEmailMessageDeliveryStatusRetrieveQuery,
  useApiPortalV1EmployeeEmailResendInvitationCreateMutation,
  useApiPortalV1EmployeeEmailValidateEmailCreateMutation,
  useApiPortalV1EmployeeEmailValidateTokenCreateMutation,
} = injectedRtkApi;
